import { z } from 'zod'

export const OrganizationTypeZod = z.enum(['ORGANIZATION', 'INSTITUTION', 'LOCAL_HOST', 'OTHER', 'ENTERPRISE'])

export const OrganizationZod = z.object({
  piloteId: z.number(),
  centralId: z.number(),
  regionId: z.string(),
  type: OrganizationTypeZod,
  name: z.string(),
  active: z.boolean(),
  version: z.number().optional().default(0),
})
export type Organization = z.infer<typeof OrganizationZod>
